// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
'use client';
import React from 'react';
import useBaseComponent from '../internal/hooks/use-base-component';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import InternalTableRow from './internal';
function TableRow(props) {
    const baseComponentProps = useBaseComponent('TableRow', {
        props: { selected: props.selected, shaded: props.shaded },
    });
    return React.createElement(InternalTableRow, { ...props, ...baseComponentProps });
}
applyDisplayName(TableRow, 'TableRow');
export default TableRow;
//# sourceMappingURL=index.js.map